import {
  AddEventServicesDto,
  BulkActivateEventsDto,
  BulkActivateEventsResponse,
  BulkCreateEventDto,
  BulkCreateEventResponse,
  CreateEventResponse,
  DeleteResponse,
  EventBodyDto,
  RemoveEventServiceDto,
  UpdateEventDto,
  WeekDto,
} from '@repo/shared/dtos'
import { EventObjectTypeResponse } from '@repo/shared/types/event.types'
import axios, { AxiosInstance } from 'axios'

class EventService {
  private api: AxiosInstance

  constructor() {
    this.api = axios.create()

    this.api.interceptors.request.use((config) => {
      const token = typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null
      if (token) {
        config.headers = config.headers || {}
        config.headers['Authorization'] = `Bearer ${token}`
      }
      return config
    })
  }

  getEvents(data: WeekDto) {
    return this.api.post<EventObjectTypeResponse[]>('/api/event/week', data)
  }

  createEvent(data: EventBodyDto) {
    return this.api.post<CreateEventResponse>('/api/event', data)
  }

  bulkCreateEvent(data: BulkCreateEventDto) {
    return this.api.post<BulkCreateEventResponse[]>('/api/event/bulk', data)
  }

  activateEvent(id: string) {
    return this.api.put<EventObjectTypeResponse>(`/api/event/${id}/activate`)
  }

  activateEvent2(data: BulkActivateEventsDto) {
    return this.api.post<BulkActivateEventsResponse[]>('/api/event/bulk/activate', data)
  }

  getEvent(id: string) {
    return this.api.get<EventObjectTypeResponse>(`/api/event/${id}`)
  }

  getEventByOldId(id: string) {
    return this.api.get<EventObjectTypeResponse>(`/api/event/by-old-id/${id}`)
  }

  updateEvent(id: string, data: UpdateEventDto) {
    return this.api.put<EventObjectTypeResponse>(`/api/event/${id}`, data)
  }

  searchEvents(search: string) {
    return this.api.get<EventObjectTypeResponse[]>('/api/event/search', { params: { search } })
  }

  deleteEvent(id: string, explanation: string) {
    return this.api.delete<DeleteResponse>(`/api/event/${id}/delete`, {
      data: { explanation },
    })
  }

  addService(data: { event: string } & AddEventServicesDto) {
    return this.api.put<EventObjectTypeResponse>(`/api/event/add-services/${data.event}`, {
      services: data.services,
    })
  }

  deleteService(id: string, service: RemoveEventServiceDto['service']) {
    return this.api.put<EventObjectTypeResponse>(`/api/event/remove-services/${id}`, {
      service: service,
    })
  }
}

export default new EventService()
